import { PrinterSchema } from "@redotech/redo-fulfillment-group-common/printer";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const watchPrinters = unaryStreamRpc({
  name: "watchPrinters",
  input: z.object({}),
  output: z.object({
    computers: z.array(PrinterSchema.shape.computer),
    printers: z.array(PrinterSchema),
    hasMultipleConnections: z.boolean().default(false),
    multipleConnectionComputerIds: z.array(z.number()).default([]),
    notEnabled: z.boolean().optional(),
  }),
});
